import { Box } from "@mui/material";

interface FormStepContainerProps {
  children: React.ReactNode;
  hidden?: boolean;
}

export const FormStepContainer = ({ children, hidden }: FormStepContainerProps) => (
  <Box display={hidden ? "none" : "grid"} gridTemplateColumns="repeat(3, 1fr)" gap={2}>
    {children}
  </Box>
);
